import React, { FC, useState } from 'react';

import { AppDispatch } from '../../redux/reducer/store';
import { useDispatch } from 'react-redux';
import { actionUpdateClaimDescription } from '../../redux/action/accessRights/actionRoles';

import ResizeModal from './resizeModal';

import styles from './editClaimDescriptionModal.module.scss';
import '../../scss/App.scss';

interface IEditModal {
	setState: (el: boolean) => void;
	state: boolean;
	elem: any;
	id: number;
}

const EditClaimDescriptionModal: FC<IEditModal> = ({
	state,
	setState,
	id,
	elem,
}) => {
	const dispatch = useDispatch<AppDispatch>();

	const [value, setValue] = useState(elem?.description?.replace(/<br>/g, '\n'));
	const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
		setValue(e.target.value);
	};

	const onCloseExit = () => {
		setState(false);
		setValue('');
	};

	const onSubmit = () => {
			dispatch(
				actionUpdateClaimDescription(id, {
					claim: {
						id: elem.role ? elem.role.id : elem.id,
					},
					description: value.replace(/\n/g, '<br>'),
				})
			);
			setState(false);
			setValue('');
	};

	const outsideClick = () => {
		setState(false);
	};

	return (
		<div className={styles.back} onClick={outsideClick}>
			<ResizeModal state={state} outsideClick={outsideClick}>
				<div className={styles.modal}>
					<div className={styles.top}>
						<div>
							<h1 className={styles.title}>Редактирование подсказки для: </h1>
							<p className={styles.description}>{elem?.role ? elem?.role?.name : elem?.name}</p>
						</div>
						<textarea
							className={styles.input}
							value={value}
							onChange={e => handleInputChange(e)}
						/>
					</div>
					<div className={styles.btnWrp}>
						<button className={styles.button} onClick={onCloseExit}>
							Отменить
						</button>
						<button className={styles.buttonSend} onClick={onSubmit}>
							Сохранить
						</button>
					</div>
				</div>
			</ResizeModal>
		</div>
	);
};

export default EditClaimDescriptionModal;